import { RootState } from "@/app/stores"
import { deleteProfileField } from "@/shared/api/profilebuilder"
import { ErrorType } from "@/shared/types"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { AxiosError } from "axios"

export const fetchDeleteFormbuilderField = createAsyncThunk<
    void,
    void,
    { state: RootState }
>('updateFormbuilderField/fetchDeleteFormbuilderField', async (_, thunkAPI) => {
    try {
        const { currentField } = thunkAPI.getState().updateFormbuilderField
        await deleteProfileField(currentField.id)
        return
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>

        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        })
    }
})